import React, { useState } from 'react';
import { Popover } from 'antd';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import CloseIcon from '@web-common/components/UI/Icons/svgs/ModalCloseSmall';
import IconCard from '@web-common/components/UI/IconCard';
import styles from './cloudAttCont.module.scss';
import { getIn18Text } from 'api';
const GUOQITEXT = getIn18Text('GUOQISHIJIAN');
export const ExpireTimeTitle = ({ isDesc, changeOrder, showSort }) => {
    const [show, setShow] = useState(false);
    let timer;
    const setHidden = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            setShow(false);
        }, 200);
    };
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const spaceInfo = [
        {
            spaceType: getIn18Text('DANGEDAXIAO'),
            free: '1G',
            flagship: '3G',
            exclusive: '5G',
        },
        {
            spaceType: getIn18Text('GUOQISHIJIAN'),
            free: getIn18Text('15TIAN'),
            flagship: getIn18Text('15TIAN'),
            exclusive: getIn18Text('YONGBUGUOQI'),
        },
        {
            spaceType: getIn18Text('ZHENGTIKONGJIAN'),
            free: '3G',
            flagship: '16G',
            exclusive: '32G',
        },
        {
            spaceType: getIn18Text('SHIFOUKEXUFEI'),
            free: getIn18Text('BUZHICHI'),
            flagship: getIn18Text('ZHICHI'),
            exclusive: getIn18Text('WUXU'),
        },
    ];
    const versions = {
        free: getIn18Text('MIANFEIBAN'),
        ultimate: getIn18Text('QIJIANBAN'),
        sirius: getIn18Text('ZUNXIANGBAN'),
    };
    const renderCurrentTag = () => React.createElement("div", { className: styles.currentTag }, getIn18Text('DANGQIANBANBEN'));
    return (React.createElement("div", { className: styles.expireTimeTitle },
        showSort ? (React.createElement("div", { className: styles.expireTime, style: { cursor: 'pointer' }, onClick: () => changeOrder && changeOrder() },
            React.createElement("span", null, GUOQITEXT),
            React.createElement(IconCard, { style: { paddingLeft: '5px' }, type: isDesc ? 'descend' : 'ascend' }))) : (React.createElement("div", { className: styles.expireTime },
            React.createElement("span", null, GUOQITEXT))),
        React.createElement(Popover, { className: styles.expireTimePopover, visible: show, content: React.createElement("div", { onMouseEnter: () => {
                    if (timer != null) {
                        clearTimeout(timer);
                    }
                }, onMouseLeave: () => {
                    setHidden();
                }, className: styles.popoverContainer },
                React.createElement("div", { className: styles.headerWrapper },
                    React.createElement("div", { className: styles.headerLeft }, getIn18Text('YOUJIANYUNFUJIAN12')),
                    React.createElement("div", { onClick: () => {
                            setShow(false);
                        }, className: styles.headerCloseIcon },
                        React.createElement(CloseIcon, null))),
                React.createElement("div", { className: styles.contentWrapper },
                    React.createElement("div", { className: styles.featureInfo },
                        React.createElement("div", { className: styles.versionTitle }, getIn18Text('BANBENGONGNENG')),
                        Object.keys(versions).map(version => (React.createElement("div", { key: version, className: styles.versionItem },
                            React.createElement("span", { className: styles.versionLabel },
                                versions[version],
                                productVersionId === version && renderCurrentTag()))))),
                    spaceInfo.map(info => (React.createElement("div", { className: styles.featureContentItem, key: info.spaceType },
                        React.createElement("div", { className: styles.featureType }, info.spaceType),
                        React.createElement("div", { className: styles.spaceSize }, info.free),
                        React.createElement("div", { className: styles.spaceSize }, info.flagship),
                        React.createElement("div", { className: styles.spaceSize }, info.exclusive)))))) },
            React.createElement("div", { className: styles.infoIcon, onMouseEnter: () => {
                    if (timer != null) {
                        clearTimeout(timer);
                    }
                    setShow(true);
                }, onMouseLeave: () => {
                    setHidden();
                } },
                React.createElement(IconCard, { type: "info" })))));
};
